export const defaultGridUnit = 8;
export const defaultMultipliers = [
  0, 0.25, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15,
];
